import React ,{useEffect, useState}from 'react';
import axios from 'axios';
import BCMSWebAgent from "../../classes/BCMSWebAgent/";

/**
 * @function BCMSMenu
 * @param {STRING} className - Additional CSS class name that's pass to the component.
 * @param {React.Component} children - Content that's contained in this page.
 * @returns {React.Component}
 * @example
 * 
 */
 const BCMSMenuContext = React.createContext(null);

export default function BCMSMenu(props) {  
  // demo does not use cctm return the childern  
  if (props.hasMenu !== true){
      window.setTimeout(function(){
         //used to delay captures until menu and model is loaded
        document.getElementById("root").setAttribute('demo', 'true')
   
       },500)
    return props.children;
  }
 
  //Get the menu xml and assign to a hook to be used in the demo

 const [dctm ,setDCTM]= useState();//Default Click thru menu

 const [menu ,setMenu]= useState();//Built menu
 


    //pass the navigation element from vasx to build menu. ∂
    
    const settings = Object.assign({
      "NODE_ENV":"production",
      "REACT_APP_MENU_URL":"/path/to/menu",
       }, props.env ?? {});
   
    const customURL = settings.NODE_ENV === "production"
      ? BCMSWebAgent.getMenuURL()
      : settings.REACT_APP_MENU_URL;
    const defaultURL  =  customURL.indexOf("onlinebanktours") !== -1
      ? customURL :
       customURL;

     
     useEffect(() => {
      (async () => {
        try {
       
          let defaultMenu = await axios.get(defaultURL).then(res=>{
            const parser = new DOMParser();
           return parser.parseFromString( res.data,"text/xml"); 
          
          });
          setDCTM(defaultMenu);
        } catch (err) {
         

         console.log(err)
        }
      })();
    }, []);

  if(dctm === undefined){
    return <>Loading menu...</>
  }else{
    if(menu === undefined ){
     
      setMenu(dctm.querySelector("*")); 
      
      
      return <>Building menu...</>
    }
  }
  window.setTimeout(function(){
    //used to delay captures until menu and model is loaded
    document.getElementById("root").setAttribute('demo', 'true')

   },500)

        return(
          <BCMSMenuContext.Provider value={dctm}>
            { <>
                {props.children}
                </>
            }
          </BCMSMenuContext.Provider> 
         
            
        );
      }
  
     
    
 

export const useMenu = () => React.useContext(BCMSMenuContext);
